import React from "react";
import { useParams } from "react-router-dom";
import { RouteParamsContext } from "./RouteParamsContext";

export const RouteParamsProvider = ({ children }) => {
  const { configCode } = useParams();

  return (
    <RouteParamsContext.Provider value={{ configCode }}>
      {children}
    </RouteParamsContext.Provider>
  );
};
